module.exports = __webpack_public_path__ + "static/media/info.b5d12aea.svg";